<!--耗金额统计-->
<template>
  <div  class="app-container">
    <div class="title-container" shadow="never">
      <div class="title-con">
        <i class="el-icon-search"></i>
        <span style="margin-left: 5px;">筛选搜索</span>
      </div>
    </div>
    <el-card class="operate-container" shadow="never" style="margin-top: 0px;">
      <div class="filter-container" style="margin-top: 10px">
        <el-form :inline="true" :model="queryParam" label-width="80px">
          <el-form-item label="月份:">
            <el-date-picker
              v-model="queryParam.month"
              type="month"
              value-format="yyyy-MM-dd"
              placeholder="选择月">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div class="button-container" style="margin-top: 0px">
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search" @click="onBtnSearch()">查 询</el-button>
      </div>
    </el-card>
    <div class="title-container" shadow="never" style="margin-top: 20px;">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">数据列表</span>
      </div>
      <div>
        <el-button type="danger" size="medium" class="operator-btn3" icon="el-icon-refresh-right" @click="handleExportSalary()">导出当前薪资表</el-button>
      </div>
    </div>
    <div class="table-container" style="margin-top: 0px;">
      <el-table ref="tableData"
                :data="tableData"
                v-loading="listLoading" border
                highlight-current-row
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}"
                :span-method="objectSpanMethod">
        <el-table-column prop="workerName" label="员工姓名" width="100"></el-table-column>
        <el-table-column prop="position" label="职位" width="100"></el-table-column>
        <el-table-column prop="baseSalary" label="底薪" width="100"></el-table-column>
        <el-table-column prop="lessonTemplateId" label="业务类型" width="150">
          <template slot-scope="scope">
            <el-select v-model="scope.row.lessonTemplateId" placeholder="请选择" disabled >
              <el-option
                v-for="item in lessonTemplateList"
                :key="item.id"
                :label="item.type"
                :value="item.id">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="buyCardSalaryDisplay" label="购卡业绩提成" width="250">
          <template slot-scope="scope">
            <span>{{scope.row.buyCardSalaryDisplay}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="useCardSalaryDisplay" label="耗课提成" >
          <template slot-scope="scope">
            <span>{{scope.row.useCardSalaryDisplay}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="classSalary" label="课时费" >
          <template slot-scope="scope">
            <span>{{scope.row.classSalary | rounding}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="inviterSalaryDisplay" label="邀请购卡提成" >
          <template slot-scope="scope">
            <span>{{scope.row.inviterSalaryDisplay}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="totalCmi" label="业绩小计" >
          <template slot-scope="scope">
            <span>{{scope.row.totalCmi | rounding}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="totalPay" label="合计" >
          <template slot-scope="scope">
            <span>{{scope.row.totalPay | rounding}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="queryParam.pageNum"
        :page-size="queryParam.pageSize"
        :page-sizes="queryParam.pageSizes"
        :total="queryParam.totalPage">
      </el-pagination>
    </div>
  </div>
</template>
<style scoped>
  /deep/ .el-table th.el-table__cell>.cell{
    width: 90%;
    height: auto;
    background: #ecf3fd;
    border-radius: 8px;
  }
  /deep/ .el-table__header-wrapper .cell{
    line-height: 45px;
    color: #0d6fb8;
  }
  /deep/ .el-dialog--center{
    border: 2px solid #d0d0d0;
    border-radius: 10px;
  }
  /deep/ .el-dialog__header{
    border-radius: 10px;
    background: #f0f7ff;
  }

</style>
<script>
  import globaldata from "../../../utils/globaldata";
  import commonUtils from "../../../utils/commonUtils";
  import {formatDate} from "../../../utils/date";
  import {calWorkerSalary, getStoreCardPerformance, queryPageStatisticsDetail} from "../../../api/mkt/MktStatistics";
  import {openDownloadDialog, sheet2blob} from "../../../utils/exportUtils";

  import ExportJsonExcel from 'js-export-excel';

  export default {
    data() {
      return {
        tableData:[],
        listLoading: true,
        queryParam :{
          storeFrontId: globaldata.getAdminStore().storeFrontId,
          //分页查询
          pageNum :1 ,//当前第几页
          totalPage :1, //总共页数
          pageSize : 10,
          pageSizes:[10,20,50,100],
          month:"",
        },
        lessonTemplateList:[],
        spanArr:[],
        pos:0,
      }
    },
    created() {
      let month = formatDate(new Date(),"yyyy-MM-dd"); //周一
      this.queryParam.month = month;
      globaldata.getStoreLessonTemplate(this.getStoreLessonTemplate);


    },
    filters: {
      rounding (value) {
        return value.toFixed(2)
      }
    },
    methods: {
      handleSizeChange(val) {
        this.queryParam.pageNum = 1;
        this.queryParam.pageSize = val;
        this.fitchData();
      },
      handleCurrentChange(val) {
        this.queryParam.pageNum = val;
        this.fitchData();
      },

      getStoreLessonTemplate(data){
        this.lessonTemplateList = data;
        let d = {
          id:null,
          type:"不区分"
        }
        this.lessonTemplateList.push(d)
        this.fitchData()
      },

      objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2 || columnIndex === 9) {
          const _row = this.spanArr[rowIndex];
          const _col = _row > 0 ? 1: 0;
          return {
            rowspan: _row,
            colspan: _col
          }
        }
      },
      //点击查询按钮
      onBtnSearch(){
        this.fitchData();
      },
      fitchData(){
        this.listLoading = true;
        let param = {
          storeFrontId: globaldata.getAdminStore().storeFrontId,
          month:this.queryParam.month,
        }
        const loading = this.myLoading();

        calWorkerSalary(param).then(response => {
          this.listLoading = false;
          loading.close();
          let data = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }

          this.refreshData(data);

        })
      },
      //刷新页面数据
      refreshData(list){

        if (commonUtils.isObjectNull(list)){
          return;
        }

        this.tableData =[];
        this.spanArr = [];
        this.pos = 0
        for (let i =0;i<list.length;++i ){
          if (i === 0) {
            this.spanArr.push(1);
            this.pos = 0
          } else {
            // 判断当前元素与上一个元素是否相同  inAccessCode（批次字段）
            if (list[i].workerId === list[i - 1].workerId) {
              this.spanArr[this.pos] += 1;
              this.spanArr.push(0);
            } else {
              this.spanArr.push(1);
              this.pos = i;
            }
          }
          this.tableData.push(list[i])
        }

        //计算应发薪资


      },

      getLessonTemplateDes(id){
        if (commonUtils.isStringNull(id)){
          return "不区分"
        }
        for (let i =0;i< this.lessonTemplateList.length;++i){
          if (this.lessonTemplateList[i].id == id){
            return this.lessonTemplateList[i].type;
          }
        }
        return "其他"
      },


      handleExportSalary(){
        const data = this.tableData;//表格数据
        var option={};
        let dataTable = [];
        if (data) {
          for (let i in data) {
            if(data){
              let bussType = this.getLessonTemplateDes(data[i].lessonTemplateId)
              let obj = {
                '员工姓名': data[i].workerName,
                '员工职位': data[i].position,
                '员工底薪': data[i].baseSalary,
                '业务类型':bussType,
                '购课提成':data[i].buyCardSalary,
                '耗课提成':data[i].useCardSalary,
                '课时费':data[i].classSalary,
                '总提成':data[i].totalCmi

              }
              dataTable.push(obj);
            }
          }
        }
        option.fileName = '薪资表_'+this.queryParam.month;
        option.datas=[
          {
            sheetData:dataTable,
            sheetName:'sheet',
            sheetFilter:['员工姓名','员工职位','员工底薪','业务类型','购课提成','耗课提成','课时费','总提成'],
            sheetHeader:['员工姓名','员工职位','员工底薪','业务类型','购课提成','耗课提成','课时费','总提成'],
          }
        ];

        var toExcel = new ExportJsonExcel(option);
        toExcel.saveExcel();
      }



    }
  }
</script>






// WEBPACK FOOTER //
// src/views/marketing-manager/mkt-worker-performance-statistics/index.vue